/* istanbul ignore file */
import Instruction from './Instruction';

export default Instruction;
